import { render, staticRenderFns } from "./ContractorsHeader.vue?vue&type=template&id=a610523e&"
import script from "./ContractorsHeader.vue?vue&type=script&lang=js&"
export * from "./ContractorsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports